export enum PAGE_LAYOUTS {
  BASIC = "BASIC",
  CUSTOMERS = "CUSTOMERS",
  EVENTS = "EVENTS",
  CASE_STUDIES = "CASE_STUDIES",
  WITHOUT_CHAT = "WITHOUT_CHAT",
}

export const CUSTOM_PAGES_HIDDEN_LAYOUTS: PAGE_LAYOUTS[] = [
  PAGE_LAYOUTS.EVENTS,
  PAGE_LAYOUTS.CASE_STUDIES
]

export enum CUSTOMERS_LOGOS_SLIDERS {
  TOP = "TOP",
  BOTTOM = "BOTTOM",
}

export const CUSTOMERS_LOGOS_OPTIONS = Object.values(CUSTOMERS_LOGOS_SLIDERS).map((slider) => ({
  label: slider[0] + slider.slice(1).toLowerCase(),
  value: slider,
}))